<template>
  <dialog-box v-if="showDialog" dialogWidth="600px" @close="closeDialog">
    {{ stopLottie() }}
    <div class="dialog-content">
      <lottie-player
        :src="fetchLottieJSON"
        background="transparent"
        speed="1"
        style="width: 100%; height: 170px"
        :loop="lottieLoop"
        class="dialog-img"
        autoplay
      ></lottie-player>
      <div class="dialog-header">
        {{
          $t(
            'account.index.currencySettings.paymentEnabledBanner.dialog.heading'
          )
        }}
      </div>
      <div class="dialog-body">
        {{
          userLevel
            ? $t(
                'account.index.currencySettings.paymentEnabledBanner.dialog.body'
              )
            : $t(
                'account.index.currencySettings.paymentEnabledBanner.dialog.alternateBody'
              )
        }}
      </div>
    </div>
  </dialog-box>
</template>

<script>
import DialogBox from '@/components/common/DialogBox'
import PaperPlane from '@/assets/images/lottie/paperplane.json'

export default {
  components: { DialogBox },
  props: ['userLevel', 'showDialog'],
  data() {
    return {
      lottieLoop: true,
      lottieJSON: PaperPlane
    }
  },
  computed: {
    fetchLottieJSON() {
      return JSON.stringify(this.lottieJSON)
    }
  },
  methods: {
    stopLottie() {
      if (this.showDialog) {
        setTimeout(() => {
          this.lottieLoop = false
        }, 4000)
      }
    },
    closeDialog() {
      this.$emit('closeDialog')
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  .dialog-img {
    object-fit: cover;
    height: 170px;
    width: 480px;
    margin: auto;
  }
  .dialog-header {
    font-weight: 700;
    font-size: 24px;
    line-height: 28px;
    text-align: center;
    color: $noble-blue-500;
    margin-top: 24px;
    margin-bottom: 8px;
  }
  .dialog-body {
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    color: $black;
    width: 90%;
    margin: auto;
    margin-bottom: 24px;
    white-space: pre-wrap;
  }
}
</style>
